import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '@/contexts/StoreContext';
import { ZoomIn, ZoomOut, RotateCcw, Focus } from 'lucide-react';
import styles from './ZoomControls.module.css';

export const ZoomControls: React.FC = observer(() => {
  const { uiStore, projectStore } = useStores();

  const handleZoomIn = () => {
    uiStore.zoomIn();
  };

  const handleZoomOut = () => {
    uiStore.zoomOut();
  };

  const handleResetZoom = () => {
    uiStore.resetViewport();
  };

  const handleZoomToSelection = () => {
    uiStore.zoomToSelection();
  };

  const zoomPercentage = Math.round(uiStore.zoom * 100);
  const hasSelection = projectStore.selectedElementIds.size > 0;

  return (
    <div className={styles['zoomControls']}>
      <button
        className={styles['zoomButton']}
        onClick={handleZoomOut}
        title="Zoom Out (Ctrl + -)"
        aria-label="Zoom out"
      >
        <ZoomOut size={16} />
      </button>
      
      <div className={styles['zoomDisplay']}>
        {zoomPercentage}%
      </div>
      
      <button
        className={styles['zoomButton']}
        onClick={handleZoomIn}
        title="Zoom In (Ctrl + +)"
        aria-label="Zoom in"
      >
        <ZoomIn size={16} />
      </button>
      
      <button
        className={styles['zoomButton']}
        onClick={handleResetZoom}
        title="Reset Zoom (Ctrl + 0)"
        aria-label="Reset zoom"
      >
        <RotateCcw size={16} />
      </button>
      
      {hasSelection && (
        <button
          className={styles['zoomButton']}
          onClick={handleZoomToSelection}
          title="Zoom to Selection (Ctrl + Shift + 0)"
          aria-label="Zoom to selection"
        >
          <Focus size={16} />
        </button>
      )}
    </div>
  );
}); 